// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Zqj8","content":"LoadingAlert_content__3t1qm"};